import { lazy } from 'react';

const Aggregator = lazy(() => import('./Aggregator'));

export default Aggregator;
